import { render, staticRenderFns } from "./custominfo-list.vue?vue&type=template&id=643a4b36&"
import script from "./custominfo-list.vue?vue&type=script&lang=js&"
export * from "./custominfo-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "custominfo-list.vue"
export default component.exports